<template>
  <div>
    <emd-text
      :class="classColor"
      size="page"
      weight="700"
      data-testid="value"
    >
      {{ sign }}{{ value }}
    </emd-text>
    <div
      v-if="text"
      class="eu-mt_2"
    >
      <p
        class="emd-text"
        :class="classColor"
        data-testid="text"
      >
        {{ $t(text) }}
      </p>
    </div>
    <slot name="tippy"></slot>
  </div>
</template>

<script>
import { EmdText } from 'emerald-vue/src/components'
export default {
  name: 'TransactionSummaryItem',
  components: {
    EmdText
  },
  props: {
    value: {
      type: [String, Number]
    },
    text: {
      type: [String, Number]
    },
    classColor: String,
    sign: String
  }
}
</script>
<i18n>
      {
        "pt-BR": {
          "title": "Resumo do recebimento",
            "boleto-amount": "Valor do boleto",
            "transfer-amount": "Valor da transferêcia",
            "charge-amount": "Valor da cobrança",
            "authorized-amount": "Valor autorizado",
            "received-amount": "Valor recebido",
            "paid-amount": "Valor pago",
            "confirmed-amount": "Valor confirmado",
            "captured-amount": "Valor capturado",
            "canceled-amount": "Valor cancelado",
            "refund-amount": "Estorno/Chargeback"
        },
        "en-US": {
          "title": "Receipt resume",
            "boleto-amount": "Boleto amount",
            "transfer-amount": "Transfer amount",
            "charge-amount": "Charge amount",
            "authorized-amount": "Authorized amount",
            "received-amount": "Received amount",
            "paid-amount": "Paid amount",
            "captured-amount": "Captured amount",
            "confirmed-amount": "Confirmed amount",
            "refund-amount": "Refund/Chargeback",
            "canceled-amount": "Canceled amount"
        }
      }
  </i18n>
